import { LISTING_CONTENT_TYPES } from 'src/components/VendorPortal/ListingLayout/shared/constants';
import type { ListingTableMap } from 'src/components/VendorPortal/ListingLayout/shared/types';
import type { FilterMap, SortMap } from 'src/helper/shared-types';

// Request Data
export const REQUEST_DATA_KEYS = {
  ADDRESS: 'address',
  CATEGORY: 'category',
  NTE: 'nte',
  RECEIVED: 'received',
} as const;
export const REQUEST_DATA_LABELS = {
  ADDRESS: 'Address',
  CATEGORY: 'Service Category',
  NTE: 'NTE Amount',
  RECEIVED: 'Received Date',
} as const;

// Requests Listing Page
export const REQUEST_PAGE_TITLE: string = 'Requests';
export const REQUEST_STATE_KEY: string = 'vendor.requests';
// Must be a field VendorRequestListResource actually returns: the request list API
// sends work_order_id but no work_order_number, so keying rows by the latter gave
// every row the key `tr-undefined` — a React duplicate-key collision (and broken
// row identity) as soon as a vendor had two pending requests.
export const REQUEST_PRIMARY_KEY: string = 'work_order_id';

// Requests Listing Filters
export const REQUEST_FILTER_KEYS = {
  CATEGORY: REQUEST_DATA_KEYS.CATEGORY,
} as const;
export const REQUEST_FILTERS_MAPPING: FilterMap[] = [
  {
    isMultiSelect: true,
    key: REQUEST_FILTER_KEYS.CATEGORY,
    label: REQUEST_DATA_LABELS.CATEGORY,
    options: [],
  },
];

// Requests Listing Sort
export const REQUEST_SORT_KEYS = {
  NTE: 'nte_amount_in_cents',
  RECEIVED: 'vendor_allocated_at',
} as const;
export const REQUEST_SORT_MAPPING: SortMap[] = [
  {
    key: REQUEST_SORT_KEYS.RECEIVED,
    ascendingLabel: 'Oldest First',
    descendingLabel: 'Newest First',
    displayFirst: 'descending',
    label: REQUEST_DATA_LABELS.RECEIVED,
  },
  {
    key: REQUEST_SORT_KEYS.NTE,
    ascendingLabel: 'Lowest First',
    descendingLabel: 'Highest First',
    displayFirst: 'descending',
    label: REQUEST_DATA_LABELS.NTE,
  },
];

// Requests Listing Table
export const REQUEST_TABLE_ID: string = 'requestsTable';
export const REQUEST_TABLE_MAPPING: ListingTableMap[] = [
  {
    className: 'category-content',
    key: REQUEST_DATA_KEYS.CATEGORY,
    label: REQUEST_DATA_LABELS.CATEGORY,
    type: LISTING_CONTENT_TYPES.CUSTOM,
  },
  {
    key: REQUEST_DATA_KEYS.ADDRESS,
    label: REQUEST_DATA_LABELS.ADDRESS,
    type: LISTING_CONTENT_TYPES.ADDRESS,
  },
  {
    key: REQUEST_DATA_KEYS.NTE,
    label: REQUEST_DATA_LABELS.NTE,
    sortable: true,
    sortKey: REQUEST_SORT_KEYS.NTE,
    type: LISTING_CONTENT_TYPES.CURRENCY,
  },
  {
    key: REQUEST_DATA_KEYS.RECEIVED,
    label: REQUEST_DATA_LABELS.RECEIVED,
    sortable: true,
    sortKey: REQUEST_SORT_KEYS.RECEIVED,
    type: LISTING_CONTENT_TYPES.TIME_ELAPSED,
  },
];

export const REQUEST_DETAILS_PANEL_EVENT: string = 'openVendorRequestSidePanel';

export const REQUEST_SIDE_PANEL_TITLE: string = 'Request Details';
